// extracted by mini-css-extract-plugin
export default {"tab_box":"UnitConsumptionSetting_tab_box__pm6Vn"};